import { render, staticRenderFns } from "./editText.vue?vue&type=template&id=b0fb8fb2&scoped=true"
import script from "./editText.vue?vue&type=script&lang=js"
export * from "./editText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0fb8fb2",
  null
  
)

export default component.exports